import { ReactNode } from 'react'

import { ChildProps } from '@/common/util/props'

import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import Text from '@/components/view/atoms/text/Text'
import Modal, { ModalType } from '@/components/view/layouts/modal/Modal'

interface Props extends ChildProps {
  showing?: boolean
  text: ReactNode
}

const Dialog = ({ children, showing, text }: Props) => {
  return (
    <Modal show={showing} type={ModalType.DIALOG}>
      <div className='max-w-100 px-6 pt-6 pb-4'>
        <div className='flex items-center gap-4 pb-6'>
          <Icon color={IconColor.WARNING} type={IconType.WARNING} size={16} line />
          <Text size={14} lineHeight={150}>
            {text}
          </Text>
        </div>
        {children}
      </div>
    </Modal>
  )
}

export default Dialog
